module.exports = {
  title: '搜索词-搜索词统计详情',
  route: {
    path: '/data-statistics',
    children: {
      path: 'search-keyword-seller-t1',
    },
  },
};
